import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { SnackbarService } from '@app/services/snackbar.service';
import { BehaviorSubject } from 'rxjs';
import { RuianSearchInterface } from '@app/interfaces/ruian-search.interface';

@Injectable({ providedIn: 'root' })
export class RuianService extends ApiService<any> {
    protected readonly snackbarService = inject(SnackbarService);

    public filteredAddresses: BehaviorSubject<RuianSearchInterface[]> = new BehaviorSubject<RuianSearchInterface[]>([]);
    public filteredCities: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

    // @API ruian
    protected serviceName = 'ruian';

    constructor() {
        super();
        this.initConnection();
    }

    public findAddress(search: string): Promise<any> | void {
        if (search) {
            // @API ruian.find
            return this.find({ query: { search } }).then((addresses: RuianSearchInterface[]) => {
                this.filteredAddresses.next(addresses);
            });
        }
    }

    public findCity(city: string): Promise<any> | void {
        if (city) {
            return this.find({ query: { city } }).then((cities: string[]) => {
                this.filteredCities.next(cities);
            });
        }
    }

    public getObject(ruianId: string): Promise<any> {
        return this.get(ruianId);
    }
}
